export default __webpack_public_path__ + "static/media/current.06cfd4a5.png";